(function(){
'use strict';
if(window.__saTiles)return; window.__saTiles=1;

var CDN='https://cdn.shopify.com/s/files/1/0818/6472/0607/files/';
var OPT='Stone';
var titleDescriptor=null;
var NOMARBLE={'Moca Creme Limestone':1,'Beige Travertine':1};

// Explicit filename map — matches the exact files uploaded in Shopify Admin > Content > Files.
// If a stone name isn't in this map, its tile shows a plain background colour instead of a broken image.
var TEX={
  'Taj White':'Taj_white.png',
  'Italian Statuario':'Italian_satuario.png',
  'Calacatta Viola':'Calacatta_Viola.png',
  'Indian Panda':'indian_panda.jpg',
  'Moca Creme Limestone':'mocha_cream_Limestone.png',
  'Beige Travertine':'Beige_travertine.jpg',
  'Fantasy Brown':'Fantasy_brown.png',
  'Forest Green':'Forest_green.jpg',
  'Indian Black':'indian_black.jpg',
  'Black Marquina':'black_marquina.jpg'
};
function texUrl(name){ return TEX[name] ? (CDN+TEX[name]) : ''; }

function css(){
  if(document.getElementById('sa-tiles-css'))return;
  var s=document.createElement('style');
  s.id='sa-tiles-css';
  s.textContent=
   '.sa-tiles{margin:6px 0 4px}'
  +'.sa-tiles__lab{font-size:11px;letter-spacing:.17em;text-transform:uppercase;color:#5A554D;display:flex;justify-content:space-between;align-items:baseline;gap:12px;margin-bottom:12px}'
  +'.sa-tiles__sel{font-size:13.5px;letter-spacing:0;text-transform:none;color:#1A1713;text-align:right}'
  +'.sa-tiles__grid{display:grid;grid-template-columns:repeat(5,1fr);gap:16px 10px}'
  +'.sa-tile{appearance:none;border:0;background:none;padding:0;margin:0;cursor:pointer;font:inherit;display:block;text-align:center}'
  +'.sa-tile__i{display:block;width:100%;aspect-ratio:1;border-radius:2px;background-color:#E7E2DA;background-size:cover;background-position:center;box-shadow:0 0 0 1px rgba(26,23,19,.16) inset;transition:box-shadow .16s}'
  +'.sa-tile:hover .sa-tile__i{box-shadow:0 0 0 1px rgba(26,23,19,.42) inset}'
  +'.sa-tile[aria-pressed="true"] .sa-tile__i{box-shadow:0 0 0 1px rgba(26,23,19,.16) inset,0 0 0 2px #1A1713,0 0 0 4px var(--sa-bg,#F5F2ED)}'
  +'.sa-tile__t{display:block;margin-top:7px;font-size:10.5px;line-height:1.25;color:#5A554D}'
  +'.sa-tile[aria-pressed="true"] .sa-tile__t{color:#1A1713}'
  +'.sa-tile[data-stone="Fantasy Brown"] .sa-tile__i{background-size:190% 126.4%;background-position:50% 45.8%}'
  +'.sa-tile[data-stone="Italian Statuario"] .sa-tile__i{background-size:175.6% 117%;background-position:50% 41.6%}'
  +'.sa-hidden-opt{display:none!important}'
  +'@media(max-width:749px){.sa-tiles__grid{grid-template-columns:repeat(4,1fr);gap:14px 8px}.sa-tile__t{font-size:10px}}';
  document.head.appendChild(s);
}

function inputsFor(optName){
  return Array.prototype.slice.call(document.querySelectorAll('variant-picker input[type="radio"]'))
    .filter(function(i){
      var n=i.getAttribute('data-option-name')||'';
      if(n) return n.toLowerCase()===optName.toLowerCase();
      var fs=i.closest('fieldset');
      var lg=fs?fs.querySelector('legend'):null;
      return !!(lg && lg.textContent.toLowerCase().indexOf(optName.toLowerCase())>-1);
    });
}

function fieldsetOf(optName){
  var ins=inputsFor(optName);
  return ins.length?ins[0].closest('fieldset'):null;
}

function labelText(input){
  var l=input.closest('label')||document.querySelector('label[for="'+input.id+'"]');
  if(l){var t=(l.textContent||'').trim(); if(t) return t;}
  return input.value;
}

var pendingStone=null;

function apply(){
  if(!pendingStone)return;
  var ins=inputsFor(OPT);
  for(var i=0;i<ins.length;i++){
    if(ins[i].value===pendingStone){ if(!ins[i].checked) ins[i].click(); pendingStone=null; return; }
  }
}

function setTitleFor(stone){
  if(!titleDescriptor)return;
  var suf=NOMARBLE[stone]?'Bath Tub':'Marble Bath Tub';
  var full=titleDescriptor+' '+stone+' '+suf;
  var h1=document.querySelector('h1');
  if(h1) h1.textContent=full;
  var sticky=document.querySelector('.sticky-add-to-cart__title');
  if(sticky) sticky.textContent=full;
}

function choose(material, stone, grid){
  pendingStone=stone;
  if(material){
    var mi=inputsFor('Material');
    for(var i=0;i<mi.length;i++){ if(mi[i].value===material && !mi[i].checked){ mi[i].click(); break; } }
  }
  setTimeout(apply,60); setTimeout(apply,240); setTimeout(apply,600);
  var btns=grid.querySelectorAll('.sa-tile');
  for(var k=0;k<btns.length;k++) btns[k].setAttribute('aria-pressed', btns[k].dataset.stone===stone?'true':'false');
  var sel=grid.parentNode.querySelector('.sa-tiles__sel');
  if(sel) sel.textContent=stone;
  setTitleFor(stone);
}

function build(map){
  var native=document.querySelector('[data-sa-native-stone]');
  if(native){
    if(!native.dataset.saBound){
      native.dataset.saBound='true';
      native.addEventListener('change',function(e){
        if(!e.target.matches('input[type="radio"]'))return;
        var sel=native.querySelector('.variant-option__swatch-value');
        if(sel)sel.textContent=e.target.value;
        setTitleFor(e.target.value);
      });
    }
    return true;
  }
  var stoneFs=fieldsetOf(OPT);
  if(!stoneFs)return false;

  // remove the previous circle selector if it is still on the page
  var old=document.querySelector('.sa-mat, .sa-matwrap, #sa-materials');
  if(old && old.parentNode) old.parentNode.removeChild(old);

  if(document.querySelector('.sa-tiles'))return true;

  var matFs=fieldsetOf('Material');
  if(matFs) matFs.classList.add('sa-hidden-opt');
  stoneFs.classList.add('sa-hidden-opt');

  var ins=inputsFor(OPT);
  var wrap=document.createElement('div');
  wrap.className='sa-tiles';

  var lab=document.createElement('div');
  lab.className='sa-tiles__lab';
  var current=ins.filter(function(i){return i.checked;})[0];
  lab.innerHTML='<span>Stone</span><span class="sa-tiles__sel"></span>';
  wrap.appendChild(lab);

  var grid=document.createElement('div');
  grid.className='sa-tiles__grid';

  ins.forEach(function(input){
    var name=input.value;
    var b=document.createElement('button');
    b.type='button';
    b.className='sa-tile';
    b.dataset.stone=name;
    b.setAttribute('aria-pressed', input.checked?'true':'false');
    b.setAttribute('title',name);
    var u=texUrl(name);
    b.innerHTML='<span class="sa-tile__i"'+(u?' style="background-image:url(\''+u+'\')"':'')+'></span><span class="sa-tile__t">'+name+'</span>';
    b.addEventListener('click',function(){ choose(map[name]||null, name, grid); });
    grid.appendChild(b);
  });

  wrap.appendChild(grid);
  stoneFs.parentNode.insertBefore(wrap, stoneFs);
  if(current) lab.querySelector('.sa-tiles__sel').textContent=current.value;
  return true;
}

function boot(){
  css();
  var m=location.pathname.match(/\/products\/([^/?#]+)/);
  if(!m)return;
  fetch('/products/'+m[1]+'.js',{headers:{Accept:'application/json'}})
    .then(function(r){return r.json();})
    .then(function(p){
      var names=p.options.map(function(o){return (typeof o==='string')?o:o.name;});
      var si=names.map(function(n){return n.toLowerCase();}).indexOf(OPT.toLowerCase());
      if(si<0)return;
      var mi=names.map(function(n){return n.toLowerCase();}).indexOf('material');
      var map={};
      p.variants.forEach(function(v){
        var opts=[v.option1,v.option2,v.option3];
        if(mi>-1) map[opts[si]]=opts[mi];
      });

      // Derive the fixed "descriptor" portion of the title (e.g. "Diamond Cut") by
      // locating whichever stone name is embedded in the product's base title, so we
      // can rebuild an accurate title for any stone the shopper selects.
      var keys=Object.keys(TEX).sort(function(a,b){return b.length-a.length;});
      for(var i=0;i<keys.length;i++){
        var idx=p.title.indexOf(keys[i]);
        if(idx>-1){ titleDescriptor=p.title.slice(0,idx).replace(/\s+$/,''); break; }
      }

      var tries=0;
      (function attempt(){
        if(build(map))return;
        if(++tries<25) setTimeout(attempt,220);
      })();
      new MutationObserver(function(){ if(!document.querySelector('.sa-tiles')) build(map); })
        .observe(document.body,{childList:true,subtree:true});
    })
    .catch(function(){});
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();
